<template>
   <div class="header" key="card">
     <!-- Top row: Logo and Sign out button -->
     <div class="header-top-row">
       <img src="../assets/SwiftAI_logo_main.svg" alt="Swift" class="header-img" />
       <div class="signout-btn-box">
         <!--<k-button class="ai-btn"  @click="onGSAIClicked">Document Summary AI</k-button>-->
         <div class="header-actions-row">
           <k-button class="encompass-btn" @click="goToEncompass" :fill-mode="'flat'">
             <i class="fa-duotone fa-building-columns"></i> Open Encompass
           </k-button>
           <div class="notification-icon-container" @click="navigateToAlerts" :title="`${alertCount} unacknowledged alerts`">
             <span class="k-icon k-i-notification"></span>
             <span v-if="alertCount > 0" class="alert-badge">{{ alertCount }}</span>
           </div>
         </div>
         <button class="signout-btn" @click="deepLogout">Sign out</button>
       </div>
     </div>
     
     <!-- Second row: Navigation tabs -->
     <div class="header-nav-row">
       <router-link :to="`/LoanTasks/?id=${loanId}`" class="router-link">LoanFlow</router-link>
       <router-link :to="`/ConsumerPortal/?id=${loanId}`" :class="['router-link']">LoanLaunch</router-link>
       <router-link :to="`/FileManager/?id=${loanId}`" class="router-link">File Manager</router-link>
       <router-link :to="`/Documents/?id=${loanId}`" class="router-link">Documents</router-link>
       <router-link :to="`/?id=${loanId}`" class="router-link">Conditions</router-link>
       <router-link :to="`/PostClose/?id=${loanId}`" :class="['router-link']">Post Close</router-link>
       <router-link :to="`/Duplicate/?id=${loanId}`" class="router-link">Duplicate</router-link>
       <router-link v-if="hasClosingRole" :to="`/Closing/?id=${loanId}`" class="router-link">Closing</router-link>
       <router-link :to="`/SwiftData/?id=${loanId}`" class="router-link">SwiftData</router-link>
       <router-link :to="`/SwiftAlerts/?id=${loanId}`" class="router-link">Alerts</router-link>
       <!--<router-link :to="`/ScenarioManager/?id=${loanId}`" class="router-link">Scenario Manager</router-link>-->
     </div>
   </div>
       <gsai-window :visible="showAi" :url="url" @toggleAIDialog="closegsai" ></gsai-window>

</template>

<script>
  import { Components } from '@formschema/native';
  import apiService from '../api/api.service.js';
  import auth from '../authConfig.js';
  import { Button } from '@progress/kendo-vue-buttons';
        import gsai from './gsAiWindow.vue'

  export default {
    data() {
      return {
        azureId: null,
        userRoles: [],
            showAi:false,
                url:''
      }
    },
 
    components:{
        'k-button': Button,
        'gsai-window':gsai
    },
    computed: {
        processingLink() {
            if (this.$route.query.swiftprocessing) {
                return true;
            }

            return false;
        },
        loanId() {
            return this.$route.query.id;
        },
        hasClosingRole() {
          return this.userRoles.includes("Closing");
        }

      , hasDevRole() {
        return this.userRoles.includes("Dev");
      }

      , alertCount() {
        return this.$store.state.unacknowledgedAlertCount || 0;
      }

      , isDevEnvironment() {
        const hostname = window.location.hostname;
        return hostname === 'localhost' || hostname === 'dev-swift.goldstarfinancial.com';
      }
    },
    async created() {
      const msalAppInstance = await auth.init();
      let tokenResponse = await auth.acquireTokenResponse();
      this.azureId = tokenResponse.uniqueId;

      const response = await apiService.GetRoles(this.azureId, tokenResponse.accessToken);
      const data = response.data;
      if (data && data.issuccess) {
        this.userRoles = data.data;
        localStorage.setItem('user_roles', data.data);
      } else {
        console.error("No valid user role data received from API");
      }
    },
    async mounted() {
      // Load alert count when component is mounted (route is ready)
      await this.loadAlertCount();
    },
    watch: {
      '$route.query.id'(newLoanId) {
        if (newLoanId) {
          this.loadAlertCount();
        }
      }
    },
    methods: {
        async loadAlertCount() {
          if (!this.loanId) {
            console.log('[Header] No loanId available yet, skipping alert count load');
            return;
          }

          try {
            console.log(`[Header] Loading alert count for loan ${this.loanId}`);
            const tokenResponse = await auth.acquireTokenResponse();
            const response = await apiService.GetLoanAlerts(this.loanId, tokenResponse.accessToken);

            if (response.data && response.data.isSuccess && response.data.data) {
              const alerts = response.data.data;
              const unacknowledgedCount = alerts.filter(a => !a.acknowledged && !a.dismissed).length;
              this.$store.commit('updateAlertCount', unacknowledgedCount);
              console.log(`[Header] Updated alert count: ${unacknowledgedCount}`);
            }
          } catch (error) {
            console.error('[Header] Failed to load alert count:', error);
          }
        },
        deepLogout() {
        }
        ,onGSAIClicked(){
            this.showAi = true,
            this.url = 'https://ai.goldstarfinancial.com/chat/summary';

        },
        closegsai(){
            this.showAi = false;
        },
        navigateToAlerts() {
          if (this.loanId) {
            this.$router.push(`/SwiftAlerts/?id=${this.loanId}`);
          }
        },
        goToEncompass() {
          if (this.loanId) {
            const url = `https://www.encompassloconnect.com/pipeline/${this.loanId}`;
            const width = screen.width * 0.8;
            const height = screen.height * 0.8;
            const left = (screen.width - width) / 2;
            const top = (screen.height - height) / 2;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top},noopener,noreferrer`);
          }
        }
    }
  }
</script>

<style>


.ai-btn {
    background-color: var(--con-primary-ltr)!important;
    font-weight: 600;
    font-size: 1.2rem;
}
  .header {
    border-bottom: 2px solid var(--accent);
    padding: 20px 10px 10px;
  }

    .header-top-row{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }

    .header-nav-row{
        display: flex;
        align-items: flex-end;
    }

    .header img{
        height:40px;
    }

    .header-nav-row .router-link {
        text-decoration: none;
        margin-bottom: 3px;
        color: var(--primary);
        font-size: 1.8rem;
        /*min-width: 90px;*/
        padding-left: 35px;
        text-align:center;
    }

    .header-nav-row .router-link:first-child {
        margin-left: 0;
    }

    .header-nav-row .router-link.disabled {
        pointer-events: none;
    }

    .header-nav-row .router-link:hover {
        color: var(--text-secondary-on-background);
    }

    .header-nav-row .router-link.router-link-active {
        color: var(--accent);
        font-weight: 600;
    }

    .header-nav-row .router-link.fade-on-hover {
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .header-nav-row .router-link.fade-on-hover:hover {
        opacity: 1;
    }

    .signout-btn-box{
        display: flex;
        align-items: center;
        position: relative;
    }

    .signout-btn {
        display: block;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        background: none;
        padding: .7rem 1rem;
        margin-left: auto;
        border: none;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .signout-btn:hover {
        opacity: 1;
        cursor: pointer;
        background: var(--accent-ltr);
        border-radius: 1rem;
    }

    /* Header Actions Row - positioned below signout */
    .header-actions-row {
        position: absolute;
        top: 100%;
        right: 0;
        margin-top: 2px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    /* Encompass Button Styles */
    .encompass-btn {
        background-color: rgba(0, 0, 0, 0.05) !important;
        border: none !important;
        border-radius: 8px !important;
        color: var(--primary) !important;
        font-weight: 500;
        padding: 8px 14px !important;
        transition: all 0.3s ease !important;
    }

    .encompass-btn:hover {
        background-color: var(--accent-ltr) !important;
    }

    .encompass-btn i {
        margin-right: 6px;
    }

    /* Notification Icon Styles */
    .notification-icon-container {
        position: relative;
        cursor: pointer;
        padding: 8px 12px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .notification-icon-container:hover {
        background-color: var(--accent-ltr);
    }

    .notification-icon-container .k-icon {
        font-size: 2.4rem;
        color: var(--primary);
    }

    .notification-icon-container .alert-badge {
        position: absolute;
        top: 2px;
        right: 4px;
        background: linear-gradient(135deg, #ef4444, #dc2626);
        color: white;
        border-radius: 50%;
        min-width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 700;
        padding: 2px 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        animation: pulse-badge 2s ease-in-out infinite;
    }

    @keyframes pulse-badge {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
    }

    @media only screen and (max-width: 1200px) and (orientation: portrait) {
        .header-nav-row .router-link {
            margin-right: 15px;
            font-size: 1.5rem;
            /*min-width: 90px;*/
        }
    }

    @media only screen and (max-width: 700px) and (orientation: portrait) {
        .header-nav-row .router-link {
            display: none;
        }

        .header-actions-row {
          display: none;
        }
    }

</style>
